"use strict";

exports.__esModule = true;
exports.sortFormattedDataByTimeBin = void 0;
var _partition3 = _interopRequireDefault(require("ramda/src/partition"));
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var sortEventsByWorkdayStart = function sortEventsByWorkdayStart(formattedValues, timezoneName, workdayStartMillis) {
  formattedValues = formattedValues.sort(function (value1, value2) {
    return Number(value1) - Number(value2);
  });
  var workdayStartHour = _momentTimezone["default"].utc(workdayStartMillis).tz(timezoneName).startOf("hour").format("HH");
  var _partition = (0, _partition3["default"])(function (value) {
      return Number(value) >= Number(workdayStartHour);
    }, formattedValues),
    current = _partition[0],
    next = _partition[1];
  return [].concat(current, next);
};
var sortFormattedDataByTimeBin = exports.sortFormattedDataByTimeBin = function sortFormattedDataByTimeBin(_ref) {
  var timeAggregationName = _ref.timeAggregationName,
    formattedValues = _ref.formattedValues,
    time = _ref.time;
  if (timeAggregationName === _timeAggregationBinMapping.HOUR_OF_DAY) {
    return sortEventsByWorkdayStart(formattedValues, time.timezone.name, time.currentWorkday.interval.startMillis);
  } else {
    return formattedValues.sort(function (a, b) {
      // $FlowFixMe - Flow does not yet support method or property calls in optional chains.
      return a == null ? void 0 : a.localeCompare(b);
    });
  }
};